/**
 * 기여자의 본인 배정 (PRD §6.2 각주 8).
 * 계정과 인력의 연결(T-2.7) 전까지는 세션에서 고른 자원이 「나」다.
 * 문서는 기여자가 작성했거나, 그 사람이 담당인 실행 작업이 연결된 이 플랜 문서만 고친다.
 */

export type SelfRef = {
  resourceId: string | null;
  name: string | null;
};

export function isOwnScheduleTask(
  task: { assignee?: string; assignedResourceId?: string },
  self: SelfRef,
): boolean {
  if (self.resourceId && task.assignedResourceId === self.resourceId) return true;
  if (self.name && task.assignee === self.name) return true;
  return false;
}

export function isOwnExecutionTask(assignees: readonly string[], self: SelfRef): boolean {
  return !!self.name && assignees.includes(self.name);
}

export function peopleOnPlan(
  tasks: readonly { assignee?: string; assignedResourceId?: string }[],
  names: Readonly<Record<string, string>>,
): { id: string; name: string }[] {
  const map = new Map<string, string>();
  for (const task of tasks) {
    if (!task.assignedResourceId) continue;
    const name = names[task.assignedResourceId] ?? task.assignee;
    if (name) map.set(task.assignedResourceId, name);
  }
  return [...map].map(([id, name]) => ({ id, name })).sort((a, b) => a.name.localeCompare(b.name, "ko"));
}
